export default __webpack_public_path__ + "static/media/LoadingAnimation.155b09d4.gif";